import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CacheProvider } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from 'date-fns/locale';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { store } from '@/store';
import { createTheme } from '@/theme';
import { createEmotionCache } from '@/utils/create-emotion-cache';
import { AuthGuard } from '@/guards/AuthGuard';
import { StagingBanner } from '@starjack/layout';
import { Toaster } from 'sonner';
import { isDevelopment } from '@/constants';
import { StarjackProvider } from '@starjack/core';
import App from './App';
import 'simplebar-react/dist/simplebar.min.css';
import './styles/global.css';

const clientSideEmotionCache = createEmotionCache();
const theme = createTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <Provider store={store}>
                    <CacheProvider value={clientSideEmotionCache}>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                adapterLocale={de}
                            >
                                <CssBaseline />

                                {isDevelopment && <StagingBanner />}

                                <StarjackProvider
                                    config={{ application: 'Backoffice' }}
                                >
                                    <AuthGuard>
                                        <App />
                                    </AuthGuard>

                                    <Toaster
                                        richColors
                                        position='bottom-right'
                                    />
                                </StarjackProvider>
                            </LocalizationProvider>
                        </ThemeProvider>
                    </CacheProvider>
                </Provider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);
